<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2>Auditoría</h2>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field label="Fecha inicio" v-model="fechaInicio" type="date"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field label="Fecha fin" v-model="fechaFin" type="date"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-select :items="tablas" label="Tabla" v-model="tabla" dense></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select :items="operaciones" label="Operación" v-model="operacion" dense></v-select>
      </v-col>

      <v-col cols="12" class="d-flex">
        <v-btn color="primary" @click="buscar">Buscar</v-btn>
        <v-btn class="ml-3" text @click="limpiar">Limpiar</v-btn>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="registros"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.datos_previos="{ item }">
            <pre style="white-space:pre-wrap; max-height:120px; overflow:auto;">{{ formatearJSON(item.datos_previos) }}</pre>
          </template>
          <template v-slot:item.datos_nuevos="{ item }">
            <pre style="white-space:pre-wrap; max-height:120px; overflow:auto;">{{ formatearJSON(item.datos_nuevos) }}</pre>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
export default {
  name: 'Auditoria',
  data(){
    return {
      fechaInicio: '',
      fechaFin: '',
      tabla: null,
      operacion: null,
      tablas: ['usuarios','miembros','pagos','ventas','productos','ajustes'],
      operaciones: ['INSERT','UPDATE','DELETE','ANULAR'],
      registros: [],
      headers: [
        { text: 'Fecha', value: 'creado_en' },
        { text: 'Tabla', value: 'tabla_nombre' },
        { text: 'Operación', value: 'operacion' },
        { text: 'Usuario', value: 'usuario_nombre' },
        { text: 'Previo', value: 'datos_previos' },
        { text: 'Nuevo', value: 'datos_nuevos' }
      ]
    }
  },
  methods: {
    async buscar(){
      const idUsuario = localStorage.getItem('idUsuario');
      if(!idUsuario){
        this.$toast && this.$toast.error('Usuario no autenticado');
        return;
      }
      const payload = {
        idUsuario: parseInt(idUsuario),
        fecha_inicio: this.fechaInicio || null,
        fecha_fin: this.fechaFin || null,
        tabla: this.tabla || null,
        operacion: this.operacion || null,
        limit: 200,
        offset: 0
      }
      try{
        const res = await HttpService.post('auditoria.php', payload);
        if(res && res.data && res.data.resultado){
          this.registros = res.data.registros;
        } else {
          this.registros = [];
          this.$toast && this.$toast.error(res.data.mensaje || 'No hay registros');
        }
      }catch(e){
        this.$toast && this.$toast.error('Error consultando auditoría');
      }
    },
    limpiar(){
      this.fechaInicio = '';
      this.fechaFin = '';
      this.tabla = null;
      this.operacion = null;
      this.registros = [];
    },
    formatearJSON(txt){
      if(!txt) return '';
      try{ return JSON.stringify(typeof txt === 'string' ? JSON.parse(txt) : txt, null, 2); }
      catch(e){ return String(txt); }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reportes/Auditoria.vue